/**
 * Turkish-specific constants used throughout the app.
 */

// Total number of allowed guesses
export const MAX_GUESSES = 6;

// Word length
export const WORD_LENGTH = 5;

// Game statuses
export const GAME_STATUS = {
  IDLE: 'idle',
  PLAYING: 'playing',
  WON: 'won',
  LOST: 'lost',
};

// Game modes
export const GAME_MODE = {
  CLASSIC: 'classic',
  CUSTOM: 'custom',
};

// Tile evaluation states
export const TILE_STATE = {
  EMPTY: 'empty',
  TBD: 'tbd',       // letter entered but not yet evaluated
  CORRECT: 'correct',
  PRESENT: 'present',
  ABSENT: 'absent',
};

// Turkish keyboard layout (Q-less Turkish keyboard)
export const KEYBOARD_ROWS = [
  ['E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P', 'Ğ', 'Ü'],
  ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'Ş', 'İ'],
  ['ENTER', 'Z', 'C', 'V', 'B', 'N', 'M', 'Ö', 'Ç', '⌫'],
];

// Valid Turkish alphabet letters (uppercase)
export const TURKISH_ALPHABET = [
  'A', 'B', 'C', 'Ç', 'D', 'E', 'F', 'G', 'Ğ',
  'H', 'I', 'İ', 'J', 'K', 'L', 'M', 'N', 'O',
  'Ö', 'P', 'R', 'S', 'Ş', 'T', 'U', 'Ü', 'V',
  'Y', 'Z',
];

// LocalStorage keys
export const LS_KEYS = {
  CLASSIC_STATE: 'os-wordle-classic',
  CUSTOM_STATE: 'os-wordle-custom',
  DARK_MODE: 'os-wordle-dark',
  THEME: 'os-wordle-theme',
  STATS: 'os-wordle-stats',
};
